module.exports = {"id":"155976","name":"Charlie Adam","rating":"74","photo":"./data/images/photos/4/155976.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CharlieAdam0.json
// module id = 762
// module chunks = 0